import { useDataChange, useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let appointment = useDataValue({
    context: 'event',
    viewPath: props.viewPath,
  })
  let setDraggedAppointment = useDataChange({
    context: 'tab',
    path: 'dragged_appointment',
    viewPath: props.viewPath,
  })

  function onMouseDown() {
    setTimeout(() => {
      setDraggedAppointment({
        appointment_type_id: appointment.appointment.type.id,
        duration: appointment.booking_duration,
      })
    }, 100)
  }

  return <View onMouseDown={onMouseDown} {...props} />
}
